import { useEffect, useState } from "react";

// format is M/D/YYYY
function getDateStringUTC(date: Date) {
  return `${
    date.getUTCMonth() + 1
  }/${date.getUTCDate()}/${date.getUTCFullYear()}`;
}

export default function LocaleDateDisplay({
  date,
  to = "toLocaleString",
}: {
  date: Date;
  to?: "toLocaleString" | "toLocaleDateString";
}) {
  const [dateString, setDateString] = useState(
    to === "toLocaleString" ? date.toUTCString() : getDateStringUTC(date)
  );

  useEffect(() => {
    setDateString(date[to]());
  }, [date, to]);

  return <>{dateString}</>;
}
